import { removeHtmlTags } from "@/utils";
import { useEffect, useState } from "react";

export const useCleanText = (keyword: string | undefined) => {
    const [cleanText, setCleanText] = useState<string | string[]>();

    useEffect(() => {
        if (keyword) setCleanText(removeHtmlTags(keyword, "<br>").cleanText);
    }, []);

    const isArrayCleanText = Array.isArray(cleanText);

    return { cleanText, isArrayCleanText };
};
